module.exports = __webpack_public_path__ + "img/popeye2.853337e5.jpg";